import { ColorCode } from './colorcode.model';
import { PartPricing } from './partpricing.model';

export class Part {
    partID: number;
    partNumber: string;
    colorCodeID: number;
    packageType: string;
    quantity: number;
    handling: string;
    isServiceReimbursable: boolean;
    warrantyPeriod: string;
    partDesc: string;
    partGroupID: number;
    isDefault: boolean;
    isActive: boolean;
    isDiscontinued: boolean;
    size: string;
    partEffectiveDate: string;
    partEndDate: string;
    replacementPartID: number;
    keywords: string;
    length: string;
    supplierName: string;
    colorCode: ColorCode;
    notes: string;
    partPricing: PartPricing;
    rollQuantity: any;
    palletquantity: any;
}



// WEBPACK FOOTER //
// ./src/opc/opc-app/part/part.model.ts